import { ProcessLocationTypeDto } from '@/api/generated';
import { CreateProcessTranslation } from '@/assets/locales/views/processes/createProcess/createProcess.translation.en.ts';

export const createProcessTranslation: CreateProcessTranslation = {
  buttons: {
    close: 'Zamknij',
    next: 'Dalej',
    startAnalysis: 'Rozpocznij analizę',
  },
  content: {
    budget: {
      budgetValueLabel: 'Max wartość',
      budgetValuePlaceholder: 'wpisz wartość',
      percentageToleranceLabel: 'Tolerancja procentowa [%]',
      percentageTolerancePlaceholder: 'wpisz wartość w %',
      title: 'Budżet',
    },
    location: {
      locationTypeLabel: 'Typ',
      locationTypePlaceholder: 'wybierz opcję',
      locationValueLabel: 'Lokalizacją w eRecruiter',
      locationValuePlaceholder: 'wpisz lokalizację',
      title: 'Lokalizacje',
    },
    recruitmentDetails: {
      extendedAtsIntegration: 'Rozszerzona integracja',
      recruitmentIdLabel: 'ID rekrutacji',
      recruitmentIdPlaceholder: 'podaj ID procesu rekrutacyjnego eRecruiter',
      recruitmentNameLabel: 'Nazwa rekrutacji',
      recruitmentNamePlaceholder: 'wpisz nazwę',
      recruitmentType: 'Tryb rekrutacji',
      selectTemplate: 'Wybierz szablon...',
      title: 'Szczegóły rekrutacji',
    },
    redFlags: {
      addNewRedFlag: 'Dodaj nową czerwoną flagę',
      infotip:
        'Wypisz w poniższym polu czerwone flagi, które należy uwzględnić przy analizie wymagań procesu.',
      newRedFlagsPlaceholder: 'wpisz ostrzeżenie',
      title: 'Czerwone Flagi',
    },
    requirements: {
      requirementsLabel: 'Opis wymagań',
      requirementsPlaceholder: 'napisz lub wklej tutaj opis stanowiska',
      title: 'Wymagania',
    },
  },
  locationTypes: {
    [ProcessLocationTypeDto.Hybrid]: 'Hybrydowa',
    [ProcessLocationTypeDto.Office]: 'W biurze',
    [ProcessLocationTypeDto.Remote]: 'Zdalnie',
  },
  recruitmentTypes: {
    B2C: 'B2C',
    REGULAR: 'Standardowy',
  },
  start: {
    accepted: 'Analiza rozpoczęta. Proces jest przygotowywany w tle.',
    errors: {
      conflict: 'Proces został już uruchomiony, zamknięty lub zarchiwizowany. Odświeżam stan.',
      default: 'Nie udało się rozpocząć procesu. Spróbuj ponownie.',
      forbidden: 'Ten proces należy do innego użytkownika i nie można go tutaj uruchomić.',
      missingRequirements: 'Opis stanowiska jest wymagany do rozpoczęcia analizy.',
      notFound: 'Ten proces już nie istnieje.',
    },
  },
  title: {
    edit: 'Edytuj proces',
    start: 'Skonfiguruj i rozpocznij analizę',
  },
};
